module.exports = __webpack_public_path__ + "img/sucos.bd12f195.svg";